var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _polygon, _polygon2, _rect9, _rect10, _path2, _path3, _path4, _circle, _circle2, _rect11, _rect12, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _rect21, _rect22, _polygon11, _polygon12, _path15, _polygon13, _polygon14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 420.89 318.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 81.4,
    y1: 220.89,
    x2: 105.02,
    y2: 235.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 101.85,
    y1: 208.91,
    x2: 122.47,
    y2: 223.29,
    gradientTransform: "translate(129.26 -26.32) rotate(31.58)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 97.59,
    y1: 229.63,
    x2: 119.55,
    y2: 243.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 59.92,
    y1: 215.18,
    x2: 82.46,
    y2: 239.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 84.74,
    y1: 219.64,
    x2: 82.02,
    y2: 260.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 359.03,
    y1: 202.62,
    x2: 247.66,
    y2: 196.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 211.57,
    y1: 157.14,
    x2: 206.32,
    y2: 266.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 206.71,
    y1: 175.51,
    x2: 215.51,
    y2: 386.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 130.7,
    y1: 233.69,
    x2: 109.23,
    y2: 244.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 312.93,
    y1: 138.14,
    x2: 215.88,
    y2: 319.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 235.49,
    y1: 109.63,
    x2: 246.27,
    y2: 109.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ead4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e9cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -689.5,
    y1: 111.35,
    x2: -678.72,
    y2: 111.35,
    gradientTransform: "matrix(-1, 0, 0, 1, -516.83, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 207.74,
    y1: 195.86,
    x2: 208.88,
    y2: 139.17,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 205.61,
    y1: 186.58,
    x2: 214.54,
    y2: 113.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 163.04,
    y1: 104.47,
    x2: 239.09,
    y2: 104.47,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 157.07,
    y1: 73.91,
    x2: 244.15,
    y2: 73.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 283.08,
    y1: 225.46,
    x2: 272.31,
    y2: 268.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 281.67,
    y1: 203.22,
    x2: 275.16,
    y2: 246.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 281.58,
    y1: 182.18,
    x2: 274.9,
    y2: 222.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 283.87,
    y1: 157,
    x2: 267.45,
    y2: 210.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 333.98,
    y1: 207.05,
    x2: 335.69,
    y2: 272.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 334.95,
    y1: 198.96,
    x2: 334.67,
    y2: 238.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 334.39,
    y1: 186.62,
    x2: 336.25,
    y2: 218.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 334.24,
    y1: 165.78,
    x2: 336.81,
    y2: 191.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 81.95,
    y1: 209.04,
    x2: 78.51,
    y2: 283.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 110.38,
    y1: 220.57,
    x2: 102.07,
    y2: 261.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 265.08,
    y1: 138.02,
    x2: 320.5,
    y2: 138.02,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 270.2,
    y1: 159.29,
    x2: 287.38,
    y2: 102.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arranging Data") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M413.21,224.38c-5.68,11.32-14.92,20.38-24,29.23-10.22,9.94-20.56,20-31.81,28.67a141.19,141.19,0,0,1-23,14.73c-27.57,13.85-59.39,16-90.23,17.57-26.44,1.35-52.92,2.47-79.4,3-23.12.46-49.14,3.36-71.87-1.77C78,312.42,71,303.18,60.58,293q-3.57-3.48-7.23-6.78C39.93,274,26,263,15.61,247.44c-16-24.13-22.88-56.09-11-82.54,9.85-22,30.81-37.09,52.44-47.74C69.39,111.06,82.36,106,94.07,98.7,116.7,84.58,133.36,63,151.57,43.46s39.81-38,66.1-42.4C251.78-4.68,286,15.27,307.48,42.39c14.06,17.76,24.28,38.9,41.79,53.23,8.6,7,18.61,12.11,27.42,18.89,10.5,8,19.1,18.36,26.15,29.55C417.91,168,425.84,199.12,413.21,224.38Z",
    transform: "translate(1.4 -0.07)",
    fill: "#68e1fd",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.36,205.82a66.84,66.84,0,0,0-16.77-44.63,9.74,9.74,0,0,1-2.31-3.4,7.73,7.73,0,0,1,.43-4.78,26.56,26.56,0,0,1,19.9-17.11l14.59,19.94C345.81,169,355.67,182.66,359,198.6s-1.94,34.87-16.33,42.48c-5.49,2.91-11.79,3.94-18,4.29-16.32.9-33.32-3-46.14-13.12-2.47-2-4.83-4.23-6.07-7.13s-1.24-6.45-.83-9.71c.94-7.5,6.39-27.75,16.3-27.46,4.94.14,10.48,6.72,14.42,9.26A80,80,0,0,0,320.36,205.82Z",
    transform: "translate(1.4 -0.07)",
    fill: "#68e1fd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 215.6,
    width: 18.04,
    height: 28.34,
    fill: "#68e1fd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 215.6,
    width: 18.04,
    height: 28.34,
    fill: "url(#linear-gradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 103.77,
    y: 208.43,
    width: 14.81,
    height: 13.97,
    transform: "translate(-94.93 90.04) rotate(-31.58)",
    fill: "#68e1fd"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 103.77,
    y: 208.43,
    width: 14.81,
    height: 13.97,
    transform: "translate(-94.93 90.04) rotate(-31.58)",
    fill: "url(#linear-gradient-2)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 101.93,
    y: 225.08,
    width: 17.25,
    height: 25.59,
    fill: "#68e1fd"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 101.93,
    y: 225.08,
    width: 17.25,
    height: 25.59,
    fill: "url(#linear-gradient-3)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 62.06,
    y: 209.48,
    width: 21.47,
    height: 38.65,
    fill: "#68e1fd"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 62.06,
    y: 209.48,
    width: 21.47,
    height: 38.65,
    fill: "url(#linear-gradient-4)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "57.2 247.41 78.67 221.57 94.56 235.67 101.43 231.66 109.16 239.11 100 248.27 57.2 247.41",
    fill: "#68e1fd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "57.2 247.41 78.67 221.57 94.56 235.67 101.43 231.66 109.16 239.11 100 248.27 57.2 247.41",
    fill: "url(#linear-gradient-5)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 316.92,
    y: 155.37,
    width: 33.51,
    height: 91.9,
    fill: "#68e1fd"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 316.92,
    y: 155.37,
    width: 33.51,
    height: 91.9,
    fill: "url(#linear-gradient-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.39,239.54c-7.78-6.31-10.52-16.91-11.68-26.86s-1.28-20.31-5.57-29.36c-5.95-12.53-18.67-20.15-30.7-27-10.35-5.93-21.3-12-33.24-12.17-8.66-.09-19.1-.3-27.25,2.64q-14.88,5.37-29.19,12.17c-5.06,2.41-10.12,5-14.31,8.73-5.23,4.67-8.82,10.89-11.88,17.2a152.1,152.1,0,0,0-13.7,45c-1.56,11.07-12.38,21.86-16.22,32.36-1.18,3.22-2.27,6.7-1.41,10,1.33,5.16,6.76,8,11.73,9.93,27.68,10.71,57.92,12.31,87.57,13.79,28.58,1.43,57.2,2.85,85.78,1.69,8.11-.33,16.4-.91,23.84-4.16s14-9.67,15.18-17.7C329.53,261.23,309.79,248.8,298.39,239.54Z",
    transform: "translate(1.4 -0.07)",
    fill: "#68e1fd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.09,190.21a2.72,2.72,0,0,1,.91-.47,2.77,2.77,0,0,1,1.36.19,21.74,21.74,0,0,0,6.9.88,7.47,7.47,0,0,1,2.41.13,6.49,6.49,0,0,1,3,2.41l4.54,5.54c.6.73,1.46,1.53,2.33,1.17a2.11,2.11,0,0,0,1-1.14,21.92,21.92,0,0,0,1.94-12.66,6,6,0,0,0-1.21-3.17,5.1,5.1,0,0,0-3.52-1.47c-3.48-.22-6.75,1.52-10.08,2.59a26.53,26.53,0,0,1-9.94,1.18,5.27,5.27,0,0,0-2.17.12,4.47,4.47,0,0,0-1.56,1.11c-1.37,1.34-6,5.51-4.35,7.49C195.46,196.33,200.52,191.3,202.09,190.21Z",
    transform: "translate(1.4 -0.07)",
    fill: "url(#linear-gradient-7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.41,231.69c1.51-1.88,2.15-11.59,4.41-12.41s15.66-3.1,18.14-2.62c21.88,4.19,41.93,20.5,64.06,17.87,15.12-1.79,29.64-6.87,43.78-12.52,6.84-2.73,14.42-5.64,21.37-3.17,5.44,1.93,9.23,6.77,12.72,11.37l17.8,23.52c1.15,1.52,2.36,3.23,2.2,5.13-.31,3.95-5.6,4.95-9.56,4.85q-88.74-2.31-177.4-6.66C111,257.05,119.19,233.21,120.41,231.69Z",
    transform: "translate(1.4 -0.07)",
    fill: "url(#linear-gradient-8)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126.62,
    cy: 235.67,
    r: 11.74,
    fill: "#68e1fd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.62,
    cy: 235.67,
    r: 11.74,
    fill: "url(#linear-gradient-9)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 255.31,
    y: 154.26,
    width: 47.93,
    height: 93.44,
    fill: "#68e1fd"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 255.31,
    y: 154.26,
    width: 47.93,
    height: 93.44,
    fill: "url(#linear-gradient-10)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.25,99.78a3.91,3.91,0,0,1,3.09,2.11c1.35,2.32,1,5.25.3,7.83-1.17,4.08-3.62,8.17-7.62,9.58a1.67,1.67,0,0,1-1.54,0A1.85,1.85,0,0,1,236,118a36.79,36.79,0,0,1-.38-7.77C235.85,107.14,238.16,99.7,242.25,99.78Z",
    transform: "translate(1.4 -0.07)",
    fill: "url(#linear-gradient-11)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.91,101.5a3.91,3.91,0,0,0-3.09,2.11c-1.35,2.32-1,5.24-.3,7.83,1.16,4.08,3.61,8.17,7.61,9.58a1.66,1.66,0,0,0,1.55,0,1.86,1.86,0,0,0,.53-1.31,36.7,36.7,0,0,0,.38-7.76C172.31,108.86,170,101.41,165.91,101.5Z",
    transform: "translate(1.4 -0.07)",
    fill: "url(#linear-gradient-12)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.37,161.67c-.59,5-2.17,10.1-.8,14.93,1.74,6.14,8.43,10.25,14.78,9.64s11.92-5.47,14-11.5c3-8.65-.57-18.06-4.09-26.51a4.36,4.36,0,0,0-4.27-3.36l-6.35-1c-4.2-.69-11.61-1.73-13.44,3.41C192.87,151,194.87,157.5,194.37,161.67Z",
    transform: "translate(1.4 -0.07)",
    fill: "url(#linear-gradient-13)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.15,152.23s-7.87,17.66-4.05,33.17l4.53,12.17,11-11.69s-10.25-18.38-7.51-31.38C196.28,148.85,191.15,152.23,191.15,152.23Z",
    transform: "translate(1.4 -0.07)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.5,154.72s.94,8.42,5.59,12.24c8,6.59,23.45,2.29,23.17-2.29s-3.56-12.24-3.56-12.24Z",
    transform: "translate(1.4 -0.07)",
    fill: "url(#linear-gradient-14)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M222.65,151.76S232.91,168,227.9,185.4l-4.06,12.41L214.3,184s6.2-7.64,6-16-.71-14.08-.71-14.08S220.74,151.76,222.65,151.76Z",
    transform: "translate(1.4 -0.07)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.2,117.71c1.45,5.07,19.51,41.16,34.54,42,20.15,1.15,27.74-23.73,29.38-29.64a136.31,136.31,0,0,0,3.2-58.43c-1-5.94-2.56-12.21-7-16.29s-11-5.16-17.06-5.7c-9.44-.82-19.12-.87-28.2,1.83C153.35,61,163.18,93.1,170.2,117.71Z",
    transform: "translate(1.4 -0.07)",
    fill: "url(#linear-gradient-15)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172,88.8c.28-.62.69-1.33,1.37-1.35s1,.41,1.43.75c2.06,1.58,5,1.08,7.44.15s4.84-2.24,7.43-2.08c2.9.19,5.33,2.18,8,3.34a14.67,14.67,0,0,0,8.12,1c5.08-.82,10.26-4.3,14.94-2.16,1.26.57,2.39,1.54,3.77,1.71,1.87.24,3.61-1.08,5.5-1.2,3.35-.23,5.79,3.28,6.47,6.57s.41,6.83,1.83,9.87a153.6,153.6,0,0,0,5.26-17.32,13,13,0,0,0,.5-4.66c-.38-2.73-2.4-5-2.72-7.75a16.82,16.82,0,0,1,.47-4.67,27.29,27.29,0,0,0-.56-11.41,14.31,14.31,0,0,0-3.07-6.14,19.31,19.31,0,0,0-5.83-3.84L218.89,42.9a41,41,0,0,0-9.48-3.78,20.89,20.89,0,0,0-16,3.08c-1.78,1.2-3.37,2.68-5.22,3.77-2.82,1.67-6.11,2.34-9.31,3.08-4.41,1-8.88,2.24-12.6,4.81s-6.63,6.73-6.56,11.26c0,1.79.51,3.56.56,5.35.16,6-4.47,11.79-2.9,17.59.66,2.45,2.35,4.35,3.39,6.61,1.13,2.47.72,4.71,1.31,7.25.74,3.21,4.89,7.3,8.29,7.23C169.34,102.08,169.09,95.55,172,88.8Z",
    transform: "translate(1.4 -0.07)",
    fill: "#606060"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172,88.8c.28-.62.69-1.33,1.37-1.35s1,.41,1.43.75c2.06,1.58,5,1.08,7.44.15s4.84-2.24,7.43-2.08c2.9.19,5.33,2.18,8,3.34a14.67,14.67,0,0,0,8.12,1c5.08-.82,10.26-4.3,14.94-2.16,1.26.57,2.39,1.54,3.77,1.71,1.87.24,3.61-1.08,5.5-1.2,3.35-.23,5.79,3.28,6.47,6.57s.41,6.83,1.83,9.87a153.6,153.6,0,0,0,5.26-17.32,13,13,0,0,0,.5-4.66c-.38-2.73-2.4-5-2.72-7.75a16.82,16.82,0,0,1,.47-4.67,27.29,27.29,0,0,0-.56-11.41,14.31,14.31,0,0,0-3.07-6.14,19.31,19.31,0,0,0-5.83-3.84L218.89,42.9a41,41,0,0,0-9.48-3.78,20.89,20.89,0,0,0-16,3.08c-1.78,1.2-3.37,2.68-5.22,3.77-2.82,1.67-6.11,2.34-9.31,3.08-4.41,1-8.88,2.24-12.6,4.81s-6.63,6.73-6.56,11.26c0,1.79.51,3.56.56,5.35.16,6-4.47,11.79-2.9,17.59.66,2.45,2.35,4.35,3.39,6.61,1.13,2.47.72,4.71,1.31,7.25.74,3.21,4.89,7.3,8.29,7.23C169.34,102.08,169.09,95.55,172,88.8Z",
    transform: "translate(1.4 -0.07)",
    fill: "url(#linear-gradient-16)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M357.42,247.66v34.62a141.19,141.19,0,0,1-23,14.73c-27.57,13.85-59.39,16-90.23,17.57-26.44,1.35-52.92,2.47-79.4,3-23.12.46-49.14,3.36-71.87-1.77C78,312.42,71,303.18,60.58,293q-3.57-3.48-7.23-6.78V247.66Z",
    transform: "translate(1.4 -0.07)",
    fill: "#68e1fd"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 257.67,
    y: 225.79,
    width: 43.37,
    height: 21.9,
    fill: "#68e1fd"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 257.67,
    y: 202.89,
    width: 43.37,
    height: 21.9,
    fill: "#68e1fd"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 257.67,
    y: 179.7,
    width: 43.37,
    height: 21.9,
    fill: "#68e1fd"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 257.67,
    y: 156.51,
    width: 43.37,
    height: 21.9,
    fill: "#68e1fd"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 257.67,
    y: 232.87,
    width: 43.37,
    height: 14.83,
    fill: "url(#linear-gradient-17)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 257.67,
    y: 212.31,
    width: 43.37,
    height: 12.48,
    fill: "url(#linear-gradient-18)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 257.67,
    y: 189.42,
    width: 43.37,
    height: 12.18,
    fill: "url(#linear-gradient-19)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 257.67,
    y: 164.82,
    width: 43.37,
    height: 13.6,
    fill: "url(#linear-gradient-20)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.08 247.48 350.43 226.01 350.43 247.27 319.08 247.48",
    fill: "#68e1fd"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.08 225.58 350.43 204.11 350.43 225.37 319.08 225.58",
    fill: "#68e1fd"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.08 203.68 350.43 182.21 350.43 203.46 319.08 203.68",
    fill: "#68e1fd"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.08 181.78 350.43 160.31 350.43 181.56 319.08 181.78",
    fill: "#68e1fd"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.08 247.48 350.43 226.01 350.43 247.27 319.08 247.48",
    fill: "url(#linear-gradient-21)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.08 225.58 350.43 204.11 350.43 225.37 319.08 225.58",
    fill: "url(#linear-gradient-22)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.08 203.68 350.43 182.21 350.43 203.46 319.08 203.68",
    fill: "url(#linear-gradient-23)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.08 181.78 350.43 160.31 350.43 181.56 319.08 181.78",
    fill: "url(#linear-gradient-24)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 68.79,
    y: 226.22,
    width: 23.76,
    height: 21.19,
    fill: "#68e1fd"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 68.79,
    y: 226.22,
    width: 23.76,
    height: 21.19,
    fill: "url(#linear-gradient-25)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.98 219.07 106.87 247.12 128.05 235.38 89.98 219.07",
    fill: "#68e1fd"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.98 219.07 106.87 247.12 128.05 235.38 89.98 219.07",
    fill: "url(#linear-gradient-26)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M320.45,136.31c-4.1-4.51-8.4-9.16-14-11.46a33.69,33.69,0,0,0-8.07-1.93,49.08,49.08,0,0,0-17.35.26,26,26,0,0,0-14.76,8.69,3.76,3.76,0,0,0-1.09,3.06,3.79,3.79,0,0,0,1.63,2,25,25,0,0,0,10,4.33c2.41.45,4.9.55,7.19,1.42s4.4,2.79,4.57,5.23c.07,1-.17,2.08.33,2.94a3.69,3.69,0,0,0,2.25,1.41c6.08,1.87,12.85,2.32,18.66-.24s11.29-9.34,10.65-15.67Z",
    transform: "translate(1.4 -0.07)",
    fill: "url(#linear-gradient-27)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "252.57 136.95 296.39 133.75 297.83 148.64 253.49 152.36 252.57 136.95",
    fill: "#68e1fd"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "252.57 136.95 296.39 133.75 297.83 148.64 253.49 152.36 252.57 136.95",
    fill: "url(#linear-gradient-28)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.c1bd21103095b71f1ba954f7180fdf4e.svg";
export { ForwardRef as ReactComponent };